/// Returns true if the given string is a valid URL (has a scheme).
export function isValidURL(url: string) {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}

/// Makes the given URL absolute by adding the https:// scheme if one doesn't exist.
export function makeAbsoluteURL(url: string) {
  if (!url.startsWith("http") && !url.startsWith("https")) {
    url = `https://${url}`;
  }

  if (isValidURL(url)) {
    return url;
  }

  return null;
}
